var objToStr = require('./objToStr');

exports = function(val) {
    var objStr = objToStr(val);
    return (
        objStr === '[object Function]' ||
        objStr === '[object GeneratorFunction]' ||
        objStr === '[object AsyncFunction]'
    );
};

module.exports = exports;
